import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { PendingDriverAssignmentsService } from 'app/modules/vehicle-inventory/services/pending-driver-assignments.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { CecoService } from 'app/rest/ceco.service';
import { Rest } from 'app/rest/rest_client';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService } from 'primeng/api';
import { PendingDriverAssignmentsFormComponent } from '../pending-driver-assignments-form/pending-driver-assignments-form.component';

@Component({
    selector: 'app-pending-driver-assignments-list',
    templateUrl: './pending-driver-assignments-list.component.html',
    styleUrls: ['./pending-driver-assignments-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PendingDriverAssignmentsListComponent extends EntityListComponent<Rest.InvPendingDriverAssignment> implements OnInit {

    @Input() vehicle: Rest.Vehicle = null;

    canDelete: boolean = false;
    companiesList: Rest.BillingAccount[] = [];
    cecoList: Rest.Ceco[] = [];

    @ViewChild(PendingDriverAssignmentsFormComponent, { static: true })
    pendingDriverAssignmentsForm: PendingDriverAssignmentsFormComponent;

    constructor(
        protected pendingDriverAssignmentsService: PendingDriverAssignmentsService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService,
        public invVehicleService: InvVehicleService,
        public cecoService: CecoService,
    ) {
        super(
            pendingDriverAssignmentsService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.pendingDriverAssignmentsForm;
        this.user = this.authenticationService.user;
        this.canDelete = this.authenticationService.isRoleGranted('INV_VEHICLE_ASSIGNMENTS_DELETE', this.user);
        this.getBillingAccounts(this.user.client.id);
        this.getCecoList();
    }

    beforeLoad(): void {
        if (this.vehicle) {
            this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];
        }
        if (!this.paginationRequest.filters['status']) {
            this.paginationRequest.filters['status'] = ['false'];
        }
        if (!this.paginationRequest.sortBy) {
            this.paginationRequest.sortBy = 'startDate';
            this.paginationRequest.sortAsc = false;
        }
    }

    afterLoad(): void {}

    public onDeleteAssignment(p: Rest.InvPendingDriverAssignment) {
        this.confirmationService.confirm({
            accept: () => {
                this.pendingDriverAssignmentsService.deleteAssignment(p.id).then(
                    () => {
                        this.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
                        this.refresh();
                    },
                    () => this.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'))
                );
            },
            key: 'pending-driver-assignments-list'
        });
    }

    public getBillingAccounts(clientId: number) {
        this.invVehicleService.getBillingAccounts(clientId).then(
            (response: Rest.BillingAccount[]) => { this.companiesList = response; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }

    public getCecoList() {
        const req = {
            sortBy: null, sortAsc: true, pageSize: 2147483647, filters: {}, loadPermissions: false
        } as unknown as Rest.ListPaginationRequest;
        this.cecoService.getPage(req).then(
            (response: Rest.Page<Rest.Ceco>) => { this.cecoList = response.entities; },
            (error: any) => console.log('The request failed: ' + error)
        );
    }
}
